import Vue from 'vue'
import firebaseAnalytics from './services/firebase-analytics'
import moment from 'moment'
import App from './App.vue'
import store from './store'
import toastr from 'toastr'
import router from './router'
import filters from '@/filters'
import vSelect from 'vue-select'
import 'nprogress/nprogress.css'
import Vuelidate from 'vuelidate'
import PortalVue from 'portal-vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import axios, { authorize } from './services/axios'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFlag } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import 'flatpickr/dist/flatpickr.css'
import VueGtm from '@gtm-support/vue2-gtm'
import VueGtag from "vue-gtag";
import {VueReCaptcha} from "vue-recaptcha-v3";
import OtpInput from "@bachdgvn/vue-otp-input";
import FeatureFlagService from "@/services/feature-flags";
import RemoteConfigService from "@/services/remote-config";

if (process.env.VUE_APP_GOOGLE_TAG_MANAGER_ID) {
  console.log('Registering GTM...');
  
  Vue.use(VueGtm, {
    id: process.env.VUE_APP_GOOGLE_TAG_MANAGER_ID,
    debug: process.env.NODE_ENV !== 'production',
    vueRouter: router
  })
}

library.add(faFlag)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.prototype.$http = axios
// Vue.prototype.$apiService = axios
Vue.prototype.$moment = moment
Vue.prototype.$toast = toastr
Vue.prototype.$analytics = firebaseAnalytics.analytics
Vue.prototype.$logEvent = firebaseAnalytics.logEvent
Vue.prototype.$eventTracker = firebaseAnalytics;


Vue.use(PortalVue)
Vue.use(Vuelidate)
Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_GOOGLE_ANALYTICS_TAG_ID, send_page_view: false }
});
Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY, loaderOptions: {autoHideBadge: true }});

Vue.component('v-select', vSelect)

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
    libraries: 'places,geometry'
  }
})

Vue.component("v-otp-input", OtpInput);

const token = localStorage.getItem('__access_token')

if (token) {
  authorize(token)
}

store
  .dispatch('auth/init')
  .then(() => {
    return RemoteConfigService.initialize();
  })
  .then(() => {
    FeatureFlagService.setFeatureFlagConfigData();
  })
  .catch(() => {})
  .finally(() => {
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  })
